
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OfferFilterValues"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferFilterValues"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mark"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarkFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FolderFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"generation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GenerationFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"gearbox"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GearboxFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"engineType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EngineTypeFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"driveType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DriveTypeFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"bodyType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BodyTypeFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerFieldType"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"year"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chosen"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChosenFieldType"},"directives":[]}]}}]}}],"loc":{"start":0,"end":785}};
    doc.loc.source = {"body":"#import \"./types/markFieldType.gql\"\n#import \"./types/folderFieldType.gql\"\n#import \"./types/generationFieldType.gql\"\n#import \"./types/gearboxFieldType.gql\"\n#import \"./types/engineTypeFieldType.gql\"\n#import \"./types/driveTypeFieldType.gql\"\n#import \"./types/bodyTypeFieldType.gql\"\n#import \"./types/ownerFieldType.gql\"\n#import \"./types/chosenFieldType.gql\"\n\nfragment OfferFilterValues on OfferFilterValues {\n  mark{\n    ... MarkFieldType\n  }\n  folder{\n    ... FolderFieldType\n  }\n  generation{\n    ... GenerationFieldType\n  }\n  gearbox{\n    ... GearboxFieldType\n  }\n  engineType{\n    ... EngineTypeFieldType\n  }\n  driveType{\n    ... DriveTypeFieldType\n  }\n  bodyType{\n    ... BodyTypeFieldType\n  }\n  owner{\n    ... OwnerFieldType\n  }\n  year\n  price\n  chosen{\n    ... ChosenFieldType\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./types/markFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./types/folderFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./types/generationFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./types/gearboxFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./types/engineTypeFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./types/driveTypeFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./types/bodyTypeFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./types/ownerFieldType.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./types/chosenFieldType.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["OfferFilterValues"] = oneQuery(doc, "OfferFilterValues");
        
